<app-modal-header>
  <div class="flex w-full items-center justify-between">
    <div class="flex items-center">
      <svg-icon src="assets/icons/icon-systematic.svg" class="my-1 w-8 text-modules-pedagocical-600"></svg-icon>
      <div class="ml-2 text-lg font-semibold text-base-ea-700" translate>sistematica.titulo-sistematica</div>
    </div>
  </div>
</app-modal-header>

<div app-modal-content class="z-0 h-[90vh] w-[90vw] bg-white p-0!">
  <form [formGroup]="form" class="flex h-full flex-col">
    <div class="no-scrollbar flex flex-grow flex-col overflow-y-auto md:overflow-y-hidden">
      <div class="flex shrink-0 flex-col gap-6 p-8 pb-4">
        <app-form-field class="w-full">
          <label app-label translate>sistematica.titulo</label>
          <input app-input maxlength="70" formControlName="title" />
        </app-form-field>

        <div class="flex w-full flex-col items-start gap-4 md:flex-row">
          @if (academicPeriod$ | async; as academicPeriod) {
            <app-form-field class="w-full shrink-0 md:w-48">
              <label app-label translate>sistematica.data-inicio</label>
              <app-input-datepicker
                [minDate]="academicPeriod[0]"
                [maxDate]="form.value.date_end"
                formControlName="date_start"
              />
            </app-form-field>

            <app-form-field class="w-full shrink-0 md:w-48">
              <label app-label translate>sistematica.data-fim</label>
              <app-input-datepicker
                [minDate]="form.value.date_start"
                [maxDate]="academicPeriod[1]"
                formControlName="date_end"
              />
            </app-form-field>
          }

          <app-form-field class="w-full flex-1">
            <label app-label translate>sistematica.turmas</label>
            <ng-select
              app-select
              formControlName="groups"
              [items]="group$ | async"
              bindLabel="descricao"
              bindValue="id"
              [multiple]="true"
              [closeOnSelect]="false"
              [clearable]="false"
            >
              <ng-template ng-multi-label-tmp let-items="items">
                <div class="ng-value !border-none !bg-transparent !p-0">
                  <span class="text-sm font-semibold text-base-ea-600">
                    {{ items.length }}
                    {{
                      (items.length === 1 ? 'sistematica.turma-selecionada' : 'sistematica.turmas-selecionadas')
                        | translate
                    }}
                  </span>
                </div>
              </ng-template>
            </ng-select>
          </app-form-field>
        </div>
      </div>

      <div class="no-scrollbar flex grow flex-col gap-6 overflow-y-visible p-8 pt-0 md:overflow-y-auto">
        <div class="flex flex-col gap-6">
          <app-form-field class="w-full">
            <label app-label translate>sistematica.descricao</label>
            <app-text-editor
              formControlName="description"
              [url]="ckeditorUploadImageUrl"
              class="mt-2"
            ></app-text-editor>
          </app-form-field>

          @if (allGroups$ | async; as allGroups) {
            @if (getSelectedGroups(allGroups); as selectedGroups) {
              @if (selectedGroups.length) {
                <div class="flex flex-col gap-2">
                  <label app-label translate class="text-[10px] font-bold uppercase tracking-widest text-gray-400">
                    sistematica.turmas-selecionadas
                  </label>
                  <div class="flex flex-wrap gap-2">
                    @for (group of selectedGroups; track group.id) {
                      <span
                        class="flex items-center gap-2 rounded-full border border-base-ea-100 bg-base-ea-50 px-3 py-1 text-xs font-semibold text-base-ea-700"
                      >
                        {{ group.descricao }}
                        <svg-icon
                          (click)="removeGroup(group.id)"
                          src="assets/icons/icon-close.svg"
                          class="h-3 w-3 cursor-pointer transition-colors hover:text-base-ea-900"
                        ></svg-icon>
                      </span>
                    }
                  </div>
                </div>
              }
            }
          }

          <app-form-field class="w-full">
            <label app-label translate>eclass.arquivos</label>

            @if (form.value.attachments?.length) {
              <div class="flex flex-col gap-2 mt-2">
                @for (attachment of form.value.attachments; track attachment.id) {
                  <div
                    class="flex w-full items-center justify-between rounded-xl border border-gray-200 bg-white p-4 shadow-sm"
                  >
                    <div class="flex items-center gap-3">
                      <svg-icon class="w-10" [src]="icon(attachment.extension)"></svg-icon>
                      <div class="overflow-hidden">
                        <p class="text-md truncate font-semibold text-gray-900">{{ attachment.title }}</p>
                        <p class="text-xs text-gray-500">{{ roundedNumber(attachment.size) }}kb</p>
                      </div>
                    </div>
                    <div class="flex items-center gap-2">
                      <button
                        type="button"
                        (click)="onOpen(attachment)"
                        class="flex h-10 w-10 items-center justify-center rounded-full text-modules-eclass-500 transition-colors hover:bg-modules-eclass-50"
                        app-tooltip
                        [tooltip]="'geral.visualizar' | translate"
                      >
                        <svg-icon class="w-6" src="assets/icons/icon-eyes.svg"></svg-icon>
                      </button>
                      <button
                        type="button"
                        (click)="removeFile(attachment)"
                        class="flex h-10 w-10 items-center justify-center rounded-full text-base-status-danger transition-colors hover:bg-red-50"
                        app-tooltip
                        [tooltip]="'geral.remover' | translate"
                      >
                        <svg-icon class="w-6" src="assets/icons/icon-close.svg"></svg-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>
            }

            @if (!enableDropzone) {
              <div
                class="mt-2 rounded-2xl border-2 border-dashed border-gray-200 bg-gray-50 p-6 transition-colors hover:border-base-ea-300"
              >
                <app-upload-file
                  [config]="config"
                  (statusChange)="onUpload($event)"
                  (processing)="disableSendUpload($event)"
                  (queueComplete)="enableSendOnUpload($event)"
                ></app-upload-file>
              </div>
            }
          </app-form-field>
        </div>
      </div>
    </div>

    <div class="shrink-0 rounded-b-lg border-t border-gray-100 bg-white p-8 pt-4">
      <div class="flex flex-row justify-between px-2 pt-3">
        <button
          (click)="onCancel()"
          app-outline-button
          class="border-base-ea-500 px-5 uppercase text-base-ea-500 enabled:hover:bg-base-ea-600 enabled:hover:text-white"
          translate
        >
          geral.cancelar
        </button>
        <button
          app-flat-button
          class="bg-base-ea-500 px-5 uppercase text-white transition-all hover:bg-base-ea-600"
          (click)="onSave()"
          [disabled]="!!submitted$.value || loading()"
          translate
        >
          {{ (loading() ? 'eclass.tarefa.salvando' : 'geral.salvar') | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
